module.exports = __webpack_public_path__ + "img/avatar2.6ad71348.svg";